export * from './lib/lot-detail-view';
